import { ComponentProps, KeyboardEvent } from 'react';
import { composeValidators, isEmail, KEY_CODES } from '@belong/common';
import { TextField } from '@belong/ui';

type Props = ComponentProps<typeof TextField>;

export function EmailField({ validate, ...rest }: Props) {
  const validators =
    typeof validate === 'function'
      ? // The cast narrows away formik's async validator form:
        // `composeValidators` short-circuits on the first truthy result, so a
        // returned promise would always read as an error message.
        composeValidators(
          isEmail,
          validate as (value: unknown) => string | undefined,
        )
      : isEmail;

  function handleEmailKeyPress(event: KeyboardEvent<HTMLInputElement>) {
    if (event.code === KEY_CODES.SPACE) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  return (
    <TextField
      onKeyPress={handleEmailKeyPress}
      {...rest}
      validate={validators}
    />
  );
}
